import { render, staticRenderFns } from "./Theaters.vue?vue&type=template&id=20f33404&"
import script from "./Theaters.vue?vue&type=script&lang=js&"
export * from "./Theaters.vue?vue&type=script&lang=js&"
import style0 from "./Theaters.vue?vue&type=style&index=0&id=20f33404&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports